/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */

export default function removeKeysWithNullValues(obj) {
  return Object.entries(obj).reduce(
    (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
    {},
  );
}
